define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var core = require('core');
    var tmpl = require('tmpl');
    var device = require('util/device.util');
    require('widgets/search.widget');
    require('common/jbone.widget');

    module.exports = $.widget('search', 'search', {

        handleActivateTap: function() {
            this.toggleSearchFix(true);
            this.super.handleActivateTap.apply(this, arguments);
        },

        activateSearch: function() {
            if (this.isActive) {
                return;
            }

            this._showClearButton();
            this.isActive = true;
            this.$el.addClass('active');

            this.renderDefaultResult();

            this.on(this.$application, {'tap': this.handleApplicationTap}, this);

            core.trigger('search:open');
        },

        deactivateSearch: function() {
            this.super.deactivateSearch.apply(this, arguments);
            this.toggleSearchFix(false);
            $(window).trigger('resize');
            $(window).trigger('scroll');
        },

        /**
         * Fix for search control on mobile
         */
        toggleSearchFix: function(action) {
            if (device.formFactor !== 'desktop') {
                $('body').toggleClass('search-fix', action);
            }
        },

        /**
         * Override core
         * Deactivate search if empty field
         */
        handleClear: function() {
            var isEmptySearch = this.$searchInput.val() === '';
            if (isEmptySearch) {
                this.deactivateSearch();
            } else {
                this.super.handleClear.apply(this, arguments);
            }
        },

        /**
         * Override core
         * Fix for iOS "no-scrolling" bug in autocomplete
         */
        _truncateVisibleResults: function() {
            var $autoComplete = this.$('.fn-autocomplete');

            if (!$autoComplete.length) {
                return;
            }

            var searchAutoCompleteItem = this.$('.fn-search-item')[0];
            var autoCompleteTop = $autoComplete[0].getBoundingClientRect().top;
            var stickyFooter = $('.fn-sticky-footer.scrollSpy-fixed');
            var stickyFooterHeight = stickyFooter ? stickyFooter.getHeight() : 0;
            var viewPortTopToAutoCompleteHeight = device.realScreenDimensions.height -
                autoCompleteTop - stickyFooterHeight;
            var visibleItemsCount = this.options.result.length > 5
                ? Math.max(3, Math.floor(viewPortTopToAutoCompleteHeight / searchAutoCompleteItem.offsetHeight))
                : this.options.result.length;
            var autoCompleteHeight = Math.min(
                viewPortTopToAutoCompleteHeight,
                searchAutoCompleteItem.offsetHeight * visibleItemsCount
            );

            $autoComplete.css('height', autoCompleteHeight + 'px');
        },
        /**
         * Override core
         * Render list with result
         */
        renderAutocomplete: function() {
            this.$('.fn-counter, .fn-autocomplete').remove();
            this.$el.removeClass('search__dropdown-mode');

            if (this.options.result.length > 0 && !_.isEqual(this.options.result, this.options.source.data)) {
                if (this.options.isShowIterator) {
                    this.$searchBar.append(tmpl['search.widget.counter'](this.options));
                }

                this.$el.append(tmpl[this.options.template](this.options));
                this.$el.addClass('search__dropdown-mode');

                this._truncateVisibleResults();

                this.on(this.$window, {'resize': this._truncateVisibleResults}, this);
            }
        }
    });
});
